<template>
    <v-container> 
        <v-card hover height="90px" style="border-radius: 8px;">
            <v-layout>
                <v-flex xs2>
            <v-avatar
            :size="60"
            >
                <v-img
                    class="elevation-6 ml-5 mt-1"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                ></v-img>
            </v-avatar>
            </v-flex>
                <v-flex xs10>
            <div class="headline mt-3"> Template </div>
            </v-flex>
            </v-layout>
        </v-card>
        <v-card hover class="mt-5" height="90px" style="border-radius: 8px;" to="/automation">
            <v-layout>
                <v-flex xs5>
                </v-flex>
                <v-flex xs8>
            <div class="headline mt-3"> + Create new template </div>
            </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>

export default {
    data(){
        return{
           
        }
    },
    methods:{
        
    }    
}
</script>
